 /// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace TabAurous.Common { 
    @Serenity.Decorators.registerClass()
    export class VoucherPostingEditor extends _Ext.GridEditorBase<Sales.SalesMasterRow> {
        public rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumnsKey() { return "Sales.SalesMaster"; }

        constructor(container: JQuery) {
            super(container); ;
            this.slickGrid.setOptions({ rowHeight: 30 }); 
        }
        private autoSize;
        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            columns.forEach(column => {
                if (column.sourceItem && column.sourceItem.editLink)
                    column.format = undefined;
            });

            return columns;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        public setData(vouchers:any[]) {
        
            for (var i = 0; i < vouchers.length; i++) {
                vouchers[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(vouchers[i]);
            }
        }
        get selectedItems(): Sales.ApprovalOutRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}